import React from 'react';
import { Box, Typography } from '@mui/material';
import { Control, useController } from 'react-hook-form';
import { FormTextField } from '../../../../component/form/FormTextField';
import { FormCheckbox } from '../../../../component/form/FormCheckbox';
import { chassisNumber } from '../../../../common/validation/Validations';
import { VinAssignmentStatus } from '../../../../generated/ApiClient';
import { HandOverValue, validPrintStatus } from './fleetHandOverSchema';
import { useTranslation } from 'react-i18next';

interface FleetRowProps {
  control: Control<any>;
  index: number;
  field: HandOverValue;
  disabled?: boolean;
}

const unselectableStatus = [VinAssignmentStatus.New, VinAssignmentStatus.Canceled];

export const FleetHandOverRow = ({
  control,
  index,
  field,
  disabled,
}: FleetRowProps) => {
  const { t } = useTranslation();

  const { field: vinField } = useController({
    name: `positions.${index}.vin`,
    control,
  });

  const { field: selectedField } = useController({
    name: `positions.${index}.selected`,
    control,
  });

  const handleVinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    vinField.onChange(newValue);

    if (validPrintStatus.includes(field.status)) {
      const validation = chassisNumber.safeParse(newValue);
      if (validation.success) {
        selectedField.onChange(true);
      }
    }
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 8fr 8fr 4fr 4fr',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography pt={1} textAlign="center">
        {field.position}
      </Typography>

      <FormTextField
        control={control}
        disabled
        name={`positions.${index}.cmsId`}
        label={t('deals.fleet.cmsId')}
        placeholder="-"
      />

      <FormTextField
        control={control}
        name={`positions.${index}.vin`}
        label={t('deals.fleet.vin')}
        disabled={disabled}
        inputProps={{ style: { textTransform: 'uppercase' } }}
        onChange={handleVinChange}
      />

      <Typography textAlign="center">{t(`deals.fleet.status.${field.status}`)}</Typography>

      <FormCheckbox
        control={control}
        name={`positions.${index}.selected`}
        label={t('deals.fleet.print')}
        disabled={disabled || unselectableStatus.includes(field.status)}
      />
    </Box>
  );
};
